import React from 'react';
import { ExclamationTriangleIcon, ArrowPathIcon } from '@heroicons/react/24/outline';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary]', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    if (this.props.fallback) {
      return this.props.fallback;
    }

    return (
      <div className="flex flex-col items-center justify-center min-h-[300px] px-8 py-16 text-center">
        <div className="w-14 h-14 rounded-full bg-amber-50 flex items-center justify-center mb-4">
          <ExclamationTriangleIcon className="w-7 h-7 text-amber-500" />
        </div>
        <h3 className="text-base font-semibold text-gray-900 mb-1">
          Something went wrong
        </h3>
        <p className="text-sm text-gray-500 max-w-md mb-6">
          An unexpected error occurred. Your data is safe — try refreshing.
        </p>
        <button
          onClick={this.handleReset}
          className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors shadow-sm"
        >
          <ArrowPathIcon className="w-4 h-4" />
          Try again
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
